import styled from 'styled-components';

export const Content = styled.div`
  flex: 1;
  padding: 40px 20px;
  display: flex;
  min-height: 70vh;
  flex-direction: column;
  align-items: center;
  text-align: center;

  h1 {
    font-size: 42px;
    color: #0E2244;
    margin-bottom: 16px;
  }

  svg {
    font-size: 90px;
    color: #0E2244;
    margin-bottom: 16px;
  }

  p {
    font-size: 16px;
    color: #444;
    max-width: 600px;

    a {
      color: #0E2244;
      text-decoration: underline;
      font-weight: 500;

      &:hover {
        opacity: 0.8;
      }
    }
  }
`;